import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-foreground-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="text-xl font-heading font-bold text-primary-300 tracking-wide">
                案件深度分析
              </span>
            </Link>
            <p className="mt-4 text-sm text-secondary-300 leading-relaxed">
              专注于重大社会案件深度分析与法律解读，为读者提供全面、客观、专业的案件资讯与分析视角。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-300 hover:text-primary-300 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-secondary-300 hover:text-primary-300 transition-colors duration-200 cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-secondary-300 hover:text-primary-300 transition-colors duration-200 cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-secondary-300 hover:text-primary-300 transition-colors duration-200 cursor-pointer"
                >
                  隐私政策
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-secondary-300 hover:text-primary-300 transition-colors duration-200 cursor-pointer"
                >
                  使用条款
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-50 mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-secondary-300">
                <i className="ri-mail-line mt-0.5"></i>
                <span>contact@case-analysis.tw</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-secondary-300">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>台湾台北市</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} 案件深度分析。本站内容仅供资讯参考，不构成法律建议。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-secondary-400 hover:text-primary-300 transition-colors duration-200 cursor-pointer" aria-label="Twitter / X">
              <i className="ri-twitter-x-line text-lg"></i>
            </a>
            <a href="#" className="text-secondary-400 hover:text-primary-300 transition-colors duration-200 cursor-pointer" aria-label="Facebook">
              <i className="ri-facebook-line text-lg"></i>
            </a>
            <a href="#" className="text-secondary-400 hover:text-primary-300 transition-colors duration-200 cursor-pointer" aria-label="RSS">
              <i className="ri-rss-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}